import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import { useI18n } from '@whizz/react-i18n';
import React from 'react';
import translations from '../translations/YearGroups';
import { useIdentity } from '@whizz/react-identity';

const YearGroupWrapper = ({ children }: Props) => {

  const { me } = useIdentity();
  const { locale, addResourceBundle } = useI18n();

  if (me) {
    const language = ((me as Teacher).getLocale().id ?? locale!.id) as keyof typeof translations;
    addResourceBundle(locale!.id, translations[language]);
  }

  return (
    <>
      {children}
    </>
  );
};

export default YearGroupWrapper;

interface Props extends Record<string, any> {
  children: React.ReactElement;
}
